export class Metadata {
  public idContent: number;
  public idCourse: number;

  constructor(idContent = 0, idCourse = 0) {
    this.idContent = idContent;
    this.idCourse = idCourse;
  }
}
